import { render, staticRenderFns } from "./OrgVideoSelect.vue?vue&type=template&id=ba3ea3e0&scoped=true"
import script from "./OrgVideoSelect.vue?vue&type=script&lang=js"
export * from "./OrgVideoSelect.vue?vue&type=script&lang=js"
import style0 from "./OrgVideoSelect.vue?vue&type=style&index=0&id=ba3ea3e0&prod&lang=less&scoped=true"
import style1 from "./OrgVideoSelect.vue?vue&type=style&index=1&id=ba3ea3e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3ea3e0",
  null
  
)

export default component.exports